module.exports = __webpack_public_path__ + "static/media/ENTRANCE-FINAL-Model-3-mobile.0284111b.webp";